var map = {
	"./bubblers.jpg": 5312,
	"./classic_oil_lamp.jpg": 4425,
	"./face_cups_with_legs.jpg": 7999,
	"./flower_cups.jpg": 7216,
	"./lady_lamp.jpg": 8830,
	"./little_face_mugs.jpg": 8460,
	"./oil_lamp_design_1.jpg": 6349,
	"./oil_lamp_design_2.jpg": 6450,
	"./small_bowls.jpg": 5428,
	"./sun_vase.jpg": 4373,
	"./tea_bowls.jpg": 5991,
	"./tea_bowls_2.jpg": 8420,
	"./tiny_vases.jpg": 7238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1978;